import { getRuleErrorMessage, URLRegex } from "@/utils/formHelper";
import { qrListPickerValidations, qrNameValidation } from "./shared";
import { TFunction } from "i18next";
export const qrWebsiteValidation = (data, t: TFunction) => {
  return [
    qrNameValidation(t),
    {
      name: "companyName",
      rules: {
        maxLength: {
          value: 50,
          message: getRuleErrorMessage("companyName", "maxLength", data),
        },
      },
    },
    {
      name: "title",
      rules: {
        maxLength: {
          value: 50,
          message: getRuleErrorMessage("title", "maxLength", data),
        },
      },
    },
    {
      name: "buttonText",
      rules: {
        maxLength: {
          value: 50,
          message: getRuleErrorMessage("buttonText", "maxLength", data),
        },
      },
    },
    {
      name: "buttonUrl",
      rules: {
        pattern: {
          value: new RegExp(URLRegex),
          message: getRuleErrorMessage("buttonUrl", "pattern", data),
        },
      },
    },
    ...qrListPickerValidations("social_invalid", t),
  ];
};
